<script setup lang="ts">
    defineProps<{
        icon?: string;
    }>();
</script>

<template>
    <v-btn variant="plain" color="secondary-text" class="text-none text-subtitle-bold" :prepend-icon="icon" height="40">
        <span class="ml-2"><slot></slot></span>
    </v-btn>
</template>

<style scoped lang="scss">
    .v-btn {
        text-transform: none;
    }

    // TODO: use mixing  of text-subtitle-bold
    .v-btn :deep(.v-btn__content) {
        /* text-subtitle-bold */
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: normal;
    }
</style>
